// extracted by mini-css-extract-plugin
export default {"vignette":"styles_vignette__POHOH"};